module.exports = __webpack_public_path__ + "img/c02_buildingpaidinblood_Normal_ua.35e4a05e.webp";